import { useState, useEffect } from 'react';

export const useCookies = () => {
  const [cookies, setCookies] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false,
  });

  useEffect(() => {
    // Load saved cookie preferences from localStorage
    const savedConsent = localStorage.getItem('cookieConsent');
    if (savedConsent) {
      try {
        const parsedConsent = JSON.parse(savedConsent);
        setCookies(parsedConsent);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
  }, []);

  const updateCookies = (newCookies) => {
    setCookies(newCookies);
    localStorage.setItem('cookieConsent', JSON.stringify(newCookies));
  };

  const hasConsent = (cookieType) => {
    return cookies[cookieType] || false;
  };

  const hasAnyConsent = () => {
    return Object.values(cookies).some((consent) => consent === true);
  };

  const resetConsent = () => {
    const defaultCookies = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    };
    updateCookies(defaultCookies);
  };

  return {
    cookies,
    updateCookies,
    hasConsent,
    hasAnyConsent,
    resetConsent,
  };
};
